import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { StoryCtaTemplateEntity } from '@modules/shared/entities';
import { StoryCtaTemplateState } from '../states';

export const storyCtaTemplateAdapter: EntityAdapter<StoryCtaTemplateEntity> = createEntityAdapter<StoryCtaTemplateEntity>();
export const initialState: StoryCtaTemplateState = storyCtaTemplateAdapter.getInitialState({
  loading: false,
  loaded: false
});